import React from "react";
import MainContentContainer from "../common/MainContentContainer";
import TopNavbar from "../components/navbar/TopNavbar";
import useMedia from "../common/mediaQuery";
import MobileHeader from "../components/header/MobileHeader";
function MainLayout(props) {
  const { children } = props;
  const IsLarge = useMedia();
  const isActive = IsLarge.useIsLarge;

  return (
    <div className="relative min-w-screen min-h-screen">
        {isActive ? <TopNavbar /> : ""}
        <MobileHeader />
        <MainContentContainer>{children}</MainContentContainer>
    </div>
  );
}

export default MainLayout;
